import React from 'react';
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const CTASection: React.FC = () => {
  const navigate = useNavigate();
  const plans = [{
    name: "Стартовый",
    price: "2,990₽",
    period: "/месяц",
    description: "Для небольших пунктов проката",
    features: ["До 100 единиц инвентаря", "2 пункта проката", "Базовая аналитика", "Техподдержка 8/5"]
  }, {
    name: "Профессиональный",
    price: "5,990₽",
    period: "/месяц",
    description: "Для растущего бизнеса",
    features: ["До 500 единиц инвентаря", "До 8 пунктов проката", "Расширенная аналитика", "Интеграции с банками", "Техподдержка 24/7"],
    popular: true
  }, {
    name: "Корпоративный",
    price: "По запросу",
    period: "",
    description: "Для крупных сетей",
    features: ["Неограниченный инвентарь", "Неограниченные пункты", "Персональная настройка", "SLA гарантии"]
  }];
  return <section id="cta" className="py-20 bg-transparent">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-left sm:text-center mb-16 px-[16px] sm:px-0">
          <h1 className="mb-4 sm:mb-8 text-slate-600 text-left sm:text-center mt-0 font-bold py-0 text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl leading-tight">
            Выберите подходящий тариф
          </h1>
          <p className="text-l text-gray-600 max-w-3xl mx-auto text-left sm:text-center">
            Начните с бесплатного периода и выберите план по мере роста бизнеса
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {plans.map((plan, index) => <div key={index} className={`relative rounded-2xl p-8 ${plan.popular ? 'bg-blue-600 text-white scale-105 shadow-2xl' : 'bg-gray-50 text-gray-900 shadow-lg'} transition-transform duration-200 hover:scale-105`}>
              {plan.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                    Популярный
                  </span>
                </div>}
              
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl font-extrabold">{plan.price}</span>
                  {plan.period && <span className="text-lg ml-1">{plan.period}</span>}
                </div>
                <p className={`mt-2 ${plan.popular ? 'text-blue-100' : 'text-gray-600'}`}>
                  {plan.description}
                </p>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-center">
                    <CheckCircle className={`h-5 w-5 mr-3 flex-shrink-0 ${plan.popular ? 'text-green-300' : 'text-green-500'}`} />
                    <span className="text-sm">{feature}</span>
                  </li>)}
              </ul>

              <Button className={`w-full ${plan.popular ? 'bg-white text-blue-600 hover:bg-gray-100' : 'bg-blue-600 text-white hover:bg-blue-700'}`} size="lg" onClick={() => navigate(plan.price === "По запросу" ? '/register' : '/register')}>
                {plan.price === "По запросу" ? "Связаться с нами" : "Попробовать бесплатно"}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>)}
        </div>

        <div className="text-center">
          <div className="bg-blue-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-blue-800 mb-4">
              Готовы начать?
            </h3>
            <p className="text-gray-700 mb-6">
              Получите 14 дней бесплатного доступа ко всем функциям. 
              Никаких обязательств, отмена в любое время.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700" onClick={() => navigate('/register')}>
                Начать бесплатный период
              </Button>
              <Button variant="outline" size="lg" onClick={() => navigate('/login')}>
                Войти в систему
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};